export const getJiraSite = (urlString: string) => {
  const url = new URL(urlString)
  const subdomains = url.hostname.split('.')

  if (subdomains.length === 2) {
    return subdomains[0]
  } else {
    return url.hostname
  }
}

export const jiraProjectsUrl = (urlString: string) => {
  const url = new URL(urlString)
  return `${hostname(url)}/jira/projects`
}

export const jiraProjectUrl = (urlString: string, projectKey: string) => {
  const url = new URL(urlString)
  return `${hostname(url)}/browse/${projectKey}`
}

export const jiraIssueUrl = (urlString: string, issueId: string) => {
  const url = new URL(urlString)
  return `${hostname(url)}/browse/${issueId}`
}

const hostname = (url: URL) => {
  return `${url.protocol}//${url.hostname}`
}
